import React from 'react'
import { useEffect } from "react";
import { Link } from 'react-router-dom';
import operationdashboard from "./images/operationdashboard.webp";
import operationdashboardmobile from "./images/operationdashboardmobile.webp";
import operation360gradientimg from "./images/operation360gradientimg.webp";
import startbuildblackarrw from "./images/startbuildblackarrw.webp";
import NavbarComponent from './navbar';
import { Container, Row, Col, Card, Button, TabContent } from "react-bootstrap";
import leadicn from "./images/leadicon.webp";
import taskicn from "./images/taskicon.webp";
import sprticn from "./images/spprticon1.webp";
import digitalicn from "./images/digitalicon.webp";
import salesicn from "./images/salesicon.webp";
import billingicn from "./images/billingicn.webp";
import leaddashboard from "./images/leaddashboard.webp";
import prospectsdashboard from "./images/prospectsdashboard.webp";
import bulklistdashboard from "./images/bulklistdashboard.webp";
import followupimg from "./images/followupimg.webp";
import activereportdash from "./images/activereportdash.webp";
import taskallocatedash from "./images/taskallocatedash.webp";
import taskupdatedash from "./images/taskupdatedash.webp";
import ticketdashboard from "./images/ticketdashboard.webp";
import digitalfiledash from "./images/digitalfiledash.webp";
import filecreatedash from "./images/filecreatedash.webp";
import jopsheetdash from "./images/jopsheetdash.webp";
import jopsheetinvicedash from "./images/jopsheetinvicedash.webp";
import payementdash from "./images/payementdash.webp";
// import efficienttracking from "./images/efficienttracking.png";
import Footer from './footer';
import TabsComponent from './tap';
import { Helmet } from 'react-helmet';

export default function Operation() {


    useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
  

    const cardData = [
        { title: "Leads & Prospects", icon: leadicn, text: "Toodhu’s robust Bulk Contact Management system streamlines lead and prospect handling through effective business workflow automation.  Leads, Prospects, and Follow-up features, this business workflow automation software ensures no opportunity is missed.  " },
        { title: "Task flow Management", icon: taskicn, text: "Task Flow Automation simplifies operations through effective business workflow automation, reducing manual effort and increasing team productivity. Toodhu helps automate business workflow by assigning, tracking, and completing tasks with minimal human input. " },
        { title: "Support Ticket Management", icon: sprticn, text: "Toodhu’s Support Ticket Management system enhances customer service through efficient business workflow automation. By leveraging business workflow automation software, support teams can track, assign, and resolve issues faster. " },
        { title: "Digital file & Documents", icon: digitalicn, text: "Toodhu simplifies file and document management through secure, centralized storage powered by business workflow automation. Teams can easily collaborate and access essential materials, enhancing both efficiency and data security. " },
        { title: "Sales flow Management", icon: salesicn, text: "Toodhu enhances sales tracking and monitoring through advanced business workflow automation, providing real-time insights for better decision-making. This business workflow automation software helps businesses automate business workflow by streamlining sales processes. " },
        { title: "Billing & Financial Accounting System (FAS)", icon: billingicn, text: "Toodhu unifies billing and accounting into one seamless platform. From  payment tracking to ledgers, expense control, and real-time financial reportsToodhu ensures accuracy, compliance, and complete financial visibility for smarter decisions. " }

    ];


    const sectionIds = [
      "leadsSection",
      "taskFlowSection",
      "supportTicketSection",
      "digitalFileSection",
       "salesFlowSection",
       "billingFileSection"
    ];
    


    const schemaData = {
    "@context": "https://schema.org",
  "@type": "Service",
  "serviceType": "Business workflow automation software",
  "name": "Toodhu Business Workflow Automation",
  "description": " Boost efficiency with Toodhu’s business workflow automation software. Simplify processes,enhance collaboration and streamline operations for faster growth.",
"url" : "https://toodhu.com/business-workflow-automation-software",
  "provider": {
    "@type": "Organization",
    "name": "Toodhu",
    "url": "https://toodhu.com",
    "telephone": "+919500944450",
    "logo": "https://toodhu.com/logo.png"
  },
  "areaServed": [
    {
      "@type": "Country",
      "name": "India"
    }
  ],
  "serviceOutput": {
    "@type": "SoftwareApplication",
    "name": "Toodhu Platform",
    "operatingSystem": "Web",
    "applicationCategory": "BusinessApplication",
    "offers": {
      "@type": "Offer",
      "priceCurrency": "INR",
      "price": "Contact for pricing",
      "url": "https://toodhu.com/pricing",
      "availability": "https://schema.org/InStock"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.8",
      "ratingCount": "120"
    }
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Contact for pricing",
    "url": "https://toodhu.com/pricing",
    "availability": "https://schema.org/LimitedAvailability"
  }


    };



    
    // const isProduction = window.location.hostname === "toodhu.com";


    
  return (

<>
<Helmet>
  <title>Business Workflow Automation Software | Toodhu</title>
  <meta charset="utf-8" />
  <meta http-equiv="X-UA-Compatible" content="IE=edge" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1" />
  <meta name="description" content="Boost efficiency with Toodhu’s business workflow automation software. Simplify processes,enhance collaboration and streamline operations for faster growth." />
  <meta name="keywords" content="Business workflow automation, Cloud-based business management, Task automation software" />
  <link rel="canonical" href="https://toodhu.com/business-workflow-automation-software" />
  <meta name="robots" content="index,follow" />
  <meta property="og:title" content="Free Business Workflow Automation AI Software  - Toodhu" />
  <meta property="og:site_name" content="Operation 360" />
  <meta property="og:url" content="https://toodhu.com/operation360" />
  <meta property="og:description" content="Boost efficiency with Toodhu’s business workflow automation software. Simplify processes,enhance collaboration and streamline operations for faster growth." />
  <meta property="og:type" content="website" />
  <meta property="og:image" content="" />
  <meta name="twitter:card" content="summary_large_image" />
  <meta name="twitter:site" content="https://toodhu.com/operation360" />
  <meta name="twitter:title" content="Free Business Workflow Automation AI Software  - Toodhu" />
  <meta name="twitter:description" content="Boost efficiency with Toodhu’s business workflow automation software. Simplify processes,enhance collaboration and streamline operations for faster growth." />
  <meta name="twitter:image" content="" />

  <script type="application/ld+json">{JSON.stringify(schemaData)}</script>
  
</Helmet>
    <div className='synergystart'>
        <div>
            <NavbarComponent/>
        </div>

          <div style={{ position: "absolute", top: "86px", right: "107px" }}>
            <TabsComponent/>
          </div>

           <section className="container synergyfirstsec" >
      <div className="row align-items-center">
        <div className="col-lg-6">
          <div className="firstbuildtitle">
          Powering Operational 
          <br /> Excellence with  
            <span className="d-block">Operation 360</span>
          </div>
        </div>
        <div className="col-lg-6">
          <p className="textmuted opsimplifytxt">
          Operation 360 simplifies business management by handling contacts, sales, customer support, and tasks all in one place. It helps you manage files, billing, and gain insights to boost efficiency and productivity.
          </p>
          <div className="d-flex gap-3">
          <Link to="/contactform"> <button className="btn btn-dark">Start building for free</button></Link>
            {/* <a href="#" className="text-decoration-none">Explore UI Screens →</a> */}
          </div>
        </div>
      </div>

     <div className='synergydashboard'>
       <img  src={operationdashboard}  className='synergyboardimg'/>   

     </div>


     <div className='synergydashboardmobile'>
  <img src={operationdashboardmobile}/> 
</div>


    </section>


<div className='operationpagebg'>
<div className="operation361 flex flex-col items-center justify-center text-center">
  <div>
    <img src={operation360gradientimg} alt="Operation Image" className='operation360gradientimg' />
    <div className='Unlockingtxt'  style={{ fontSize: "31.29px" }} >Unlocking Success: The Power of Smart Operations with Toodhu</div>
  </div>
</div>

<Container className="py-5 iconcardsec">
  <Row className="g-4 justify-content-center">
    {cardData.map((card, index) => (
      <Col key={index} xs={12} sm={6} md={6} lg={4} xl={4} className="d-flex">
        <Card className="w-100">
          <Card.Body className='operationcardbody'>
            <div className="fs-2 mb-3 text-primary">
              {typeof card.icon === "string"  ? (
                <img src={card.icon} alt={card.title} width="87" height="87" />
              ) : (
                card.icon
              )}
            </div>
            <Card.Title className="fw-bold">{card.title}</Card.Title>
            <div id='crdtxt'>{card.text}</div>
            <Button variant="outline-light" className='leanbtn'   onClick={() => document.getElementById(sectionIds[index]).scrollIntoView({ behavior: "smooth" })}
            >Learn more →</Button>
          </Card.Body>
        </Card>
      </Col>
    ))}
  </Row>
</Container>

<div className='interfacesection' id="leadsSection">
<h3 className='intermadetxt' id='intermade'>Interfaces <br />
made for <span className='intermadetspanxt'>Collaboration.</span></h3>
<div className='universetxt'>Built screens for Universal needs.</div>
</div>


</div>





<Container className="my-5 leadingdashsec" id='leadingdashsec'>
      <Row className="align-items-center">
        {/* Left Side (Image Placeholder) */}
        <Col className="col-lg-6 col-md-12 col-sm-12 col-xs-12 d-lg-block d-none leadtop">
        <img  src={leaddashboard}  className='leaddashboard'/>  

        </Col>

        {/* Right Side - Text Section */}
        <Col lg={6} className="ps-lg-5">
          <h2 className="leadtxt">Leads Status Dashboard</h2>
          <h1 className="leadpara">
The Lead Status Dashboard provides a clear and comprehensive view of all leads, enabling businesses to automate business workflow by tracking current status, progress, and next steps. It offers real-time insights into each lead's journey, helping teams prioritize follow-ups and make informed decisions with the help of business workflow automation software, ultimately driving conversions efficiently.          </h1>
        </Col>


        <Col lg={6} className="d-lg-none d-block">
        <img  src={leaddashboard}  className='leaddashboard'/>  

        </Col>

      </Row>
    </Container>



<div className='porspectssec'>
<Container className="my-5 prospectconatiner">
      <Row className="align-items-center">

        {/* Right Side - Text Section */}
        <Col lg={6} className="ps-lg-5">
          <h2 className="prospectxt">Prospects</h2>
          <p className="prospecpara">
The Prospects section helps businesses organize and manage potential customers, tracking interactions and engagement levels to automate business workflow. This feature ensures no prospect is overlooked, enabling teams to nurture relationships effectively using business workflow automation software, ultimately guiding prospects toward becoming loyal customers.          </p>
        </Col>

        {/* Left Side (Image Placeholder) */}
        <Col lg={6} className="">
        <img  src={prospectsdashboard}  className='prospectsdashboard'/>  

        </Col>

      </Row>
    </Container>
</div>



<Container className="my-5 leadingdashsec">
      <Row className="align-items-center">
        {/* Left Side (Image Placeholder) */}
        <Col className="col-lg-6 col-md-12 col-sm-12 col-xs-12 d-lg-block d-none leadtop">
        <img  src={bulklistdashboard}  className='leaddashboard'/>  

        </Col>

        {/* Right Side - Text Section */}
        <Col lg={6} className="ps-lg-5">
          <h2 className="leadtxt">Bulk Contact Posting</h2>
          <p className="leadpara">
Bulk Contact Posting enables efficient management of large contact lists by allowing users to upload and categorize contacts in bulk. This feature supports business workflow automation by saving time and ensuring all contacts are properly organized and easily accessible for future outreach and communication, helping to automate business workflow seamlessly.          </p>
        </Col>

        <Col lg={6} className="d-lg-none d-block">
        <img  src={bulklistdashboard}  className='leaddashboard'/>  

        </Col>

      </Row>
    </Container>



    <div className='porspectssec'>
<Container className="my-5 prospectconatiner">
      <Row className="align-items-center">

        {/* Right Side - Text Section */}
        <Col lg={6} className="ps-lg-5">
          <h2 className="prospectxt">Follow Up</h2>
          <p className="prospecpara">
The Follow-Up feature automates and tracks interactions with leads and prospects, ensuring timely communication and engagement. With automated reminders and notifications, this business workflow automation software helps teams automate business workflow, build stronger relationships, and increase conversion rates efficiently.          </p>
        </Col>

        {/* Left Side (Image Placeholder) */}
        <Col lg={6} className="">
        <img  src={followupimg}  className='followupdashboard'/>  

        </Col>

      </Row>
    </Container>
</div>




<div className='interfacesection'   id="taskFlowSection">
<div className='intermadetxt taskflowtxt'>Taskflow Management</div>
<div className='universetxt1'>Task Flow Management automates and organizes tasks to improve team productivity and ensure timely completion, enhancing overall business workflow automation and helping teams automate business workflow effectively.</div>
</div>

<Container className="my-5 leadingdashsec">
      <Row className="align-items-center">
        {/* Left Side (Image Placeholder) */}
        <Col className="col-lg-6 col-md-12 col-sm-12 col-xs-12 d-lg-block d-none leadtop">
        <img  src={activereportdash}  className='leaddashboard'/>  

        </Col>

        {/* Right Side - Text Section */}
        <Col lg={6} className="ps-lg-5">
          <h2 className="leadtxt">Activity Report</h2>
          <p className="leadpara">
The Activity Report provides detailed insights into the completion status of tasks and activities. It helps teams track progress, identify bottlenecks, and assess performance, supporting business workflow automation by enabling data-driven decisions to improve and automate business workflow effectively.          </p>
        </Col>

        <Col lg={6} className="d-lg-none d-block">
        <img  src={activereportdash}  className='leaddashboard'/>  

        </Col>


      </Row>
    </Container>



<div className='porspectssec'>
<Container className="my-5 prospectconatiner">
      <Row className="align-items-center">

        {/* Right Side - Text Section */}
        <Col lg={6} className="ps-lg-5">
          <h2 className="prospectxt">Task Allocation</h2>
          <p className="prospecpara">
Task Allocation allows managers to assign tasks to team members based on priority and skill set. This feature supports business workflow automation by ensuring work is evenly distributed, deadlines are met, and teams automate business workflow efficiently by focusing on the right tasks at the right time.          </p>
        </Col>

        {/* Left Side (Image Placeholder) */}
        <Col lg={6} className="">
        <img  src={taskallocatedash}  className='prospectsdashboard'/>  

        </Col>

      </Row>
    </Container>
</div>



<Container className="my-5 leadingdashsec">
      <Row className="align-items-center">
        {/* Left Side (Image Placeholder) */}
        <Col className="col-lg-6 col-md-12 col-sm-12 col-xs-12 d-lg-block d-none leadtop">
        <img  src={taskupdatedash}  className='leaddashboard'/>  

        </Col>

        {/* Right Side - Text Section */}
        <Col lg={6} className="ps-lg-5">
          <h2 className="leadtxt">Task Updation</h2>
          <p className="leadpara">
          Task Updation keeps the entire team informed with real-time updates on task status, changes, and progress. This feature ensures everyone is on the same page, facilitating better collaboration and timely completion of tasks.
          </p>
        </Col>

        <Col lg={6} className="d-lg-none d-block">
        <img  src={taskupdatedash}  className='leaddashboard'/>  

        </Col>

      </Row>
    </Container>






    <div className='interfacesection '  id="supportTicketSection">
<div className='intermadetxt intersectiongery' id="taskFlowSection">Support Ticket Management</div>
<div className='universetxt1'>Support Ticket Management streamlines the tracking and resolution of customer issues, providing quick and efficient support. This system is a vital part of business workflow automation software, helping businesses automate business workflow in customer service for improved satisfaction and faster issue resolution.</div>
</div>

<Container className="my-5 leadingdashsec">
      <Row className="align-items-center">
        {/* Left Side (Image Placeholder) */}
        <Col className="col-lg-6 col-md-12 col-sm-12 col-xs-12 d-lg-block d-none leadtop">
        <img  src={ticketdashboard}  className='leaddashboard'/>  

        </Col>

        {/* Right Side - Text Section */}
        <Col lg={6} className="ps-lg-5">
          <h2 className="leadtxt">Tickets Dashboard</h2>
          <p className="leadpara">
The Ticket Dashboard provides an overview of all support tickets, displaying key metrics such as open, closed, and pending tickets. This feature supports business workflow automation by helping teams stay on top of customer issues, prioritize tasks, and automate business workflow for timely resolution.          </p>
        </Col>

        <Col lg={6} className="d-lg-none d-block">
        <img  src={ticketdashboard}  className='leaddashboard'/>  

        </Col>

      </Row>
    </Container>

    <div className='interfacesection' style={{ marginTop: "81.29px" }} id='digitalFileSection' >
<div className='intermadetxt intersectiongery'>Digital File Documents</div>
<div className='universetxt1'>Digital File Document Management lets businesses store, organize, and securely access files for quick retrieval.</div>
</div>


<div className='porspectssec'>
<Container className="my-5 prospectconatiner">
      <Row className="align-items-center">

        {/* Right Side - Text Section */}
        <Col lg={6} className="ps-lg-5">
          <h2 className="prospectxt">Digital File Management</h2>
          <p className="prospecpara">
Digital File Management enables businesses to efficiently manage and organize all digital files in a centralized location. This feature enhances business workflow automation by helping teams collaborate seamlessly, ensuring documents are easy to find, share, and update, which supports efforts to automate business workflow and improve overall efficiency.          </p>
        </Col>

        {/* Left Side (Image Placeholder) */}
        <Col lg={6} className="">
        <img  src={digitalfiledash}  className='prospectsdashboard'/>  

        </Col>

      </Row>
    </Container>
</div>





<Container className="my-5 leadingdashsec">
      <Row className="align-items-center">
        {/* Left Side (Image Placeholder) */}
        <Col className="col-lg-6 col-md-12 col-sm-12 col-xs-12 d-lg-block d-none leadtop">
        <img  src={filecreatedash}  className='leaddashboard'/>  

        </Col>

        {/* Right Side - Text Section */}
        <Col lg={6} className="ps-lg-5">
          <h2 className="leadtxt">File Creation</h2>
          <p className="leadpara">
File Creation allows users to generate new documents directly within the system, making it easy to create, edit, and store files in real-time. This capability supports business workflow automation by ensuring necessary documents are readily available, helping teams automate business workflow and maintain smooth collaboration.          </p>
        </Col>


        <Col lg={6} className="d-lg-none d-block">
        <img  src={filecreatedash}  className='leaddashboard'/>  

        </Col>

      </Row>
    </Container>





    <div className='interfacesection' style={{ marginTop: "81.29px" }} id='salesFlowSection'>
<div className='intermadetxt intersectiongery' id='salesflw'>Sales Flow Management</div>
<div className='universetxt1' id='universetxt1'>Sales Tracking & Monitoring allows businesses to track their sales performance in real time, providing insights to make data-driven decisions. This feature supports business workflow automation by ensuring a smooth sales process and helping teams automate business workflow effectively to drive business growth.</div>
</div>


<div className='porspectssec'>
<Container className="my-5 prospectconatiner">
      <Row className="align-items-center">

        {/* Right Side - Text Section */}
        <Col lg={6} className="ps-lg-5">
          <h4 className="prospectxt">Job Sheet Dashboard</h4>
          <p className="prospecpara">
          Provides an overview of all job sheets, helping businesses track progress and manage tasks efficiently.
          </p>
        </Col>

        {/* Left Side (Image Placeholder) */}
        <Col lg={6} className="">
        <img  src={jopsheetdash}  className='prospectsdashboard'/>  

        </Col>

      </Row>
    </Container>
</div>


    <div className='interfacesection' style={{ marginTop: "81.29px" }} id='billingFileSection' >
<div className='intermadetxt intersectiongery'>Billing & Financial Accounting System (FAS)</div>
<div className='universetxt1'>Toodhu unifies billing and accounting into one seamless platform. From payment tracking to ledgers, expense control.</div>
</div>


<Container className="my-5 leadingdashsec">
      <Row className="align-items-center">
        {/* Left Side (Image Placeholder) */}
        <Col className="col-lg-6 col-md-12 col-sm-12 col-xs-12 d-lg-block d-none leadtop">
        <img  src={jopsheetinvicedash}  className='leaddashboard'/>  

        </Col>

        {/* Right Side - Text Section */}
        <Col lg={6} className="ps-lg-5">
          <h2 className="leadtxt">Job Sheet Invoice</h2>
          <p className="leadpara">
          Generates accurate invoices based on completed job sheets, ensuring seamless billing and financial tracking.
          </p>
        </Col>

        <Col lg={6} className="d-lg-none d-block">
        <img  src={jopsheetinvicedash}  className='leaddashboard'/>  

        </Col>

      </Row>
    </Container>





    <div className='porspectssec'>
<Container className="my-5 prospectconatiner">
      <Row className="align-items-center">

        {/* Right Side - Text Section */}
        <Col lg={6} className="ps-lg-5">
          <h2 className="prospectxt">Payment</h2>
          <p className="prospecpara">
          Enables secure processing and tracking of payments, ensuring smooth financial transactions and record-keeping.
          </p>
        </Col>

        {/* Left Side (Image Placeholder) */}
        <Col lg={6} className="">
        <img  src={payementdash}  className='payemntsdashboard'/>  

        </Col>

      </Row>
    </Container>
</div>

<br></br>
<br></br>

<div className='efficienttrackingbg' >
<Container
      
      className="text-white py-5"
      style={{
        // background: "linear-gradient(90deg, #000000 0%, #1c1032 100%)",
        minHeight: "580px"
      }}
    >
      <Row className="align-items-center">
        {/* Left Side Image */}
        <Col xs={12} md={6} className="mb-4 mb-md-0">
          {/* <img
            src={efficienttracking}
            alt="CRM Illustration"
            className="img-fluid"
            style={{ maxHeight: "300px" }}
          /> */}
        </Col>

        {/* Right Side Text */}
        <Col xs={12} md={6}>
          <div className="fw-bold crmtdytxt">
          Get started today and elevate your business with Operation 360 to new heights!
          </div>
          <h5 className="my-4 crmtdytxt1" style={{ maxWidth: "450px" }}>
          Whether you're aiming to optimize your processes or expand your operations, Operation 360 is designed to elevate your business to new heights. Don’t wait—begin transforming your business today!
          </h5>
         <Link to="/contactform"><Button variant="light" className="fw-semibold crmtdybtn">
          Start building for free <span><img src={startbuildblackarrw}/></span>
          </Button></Link>
        </Col>
      </Row>
    </Container>
</div>


<div className='ftr'>
    <Footer/>
</div>



    </div>
    </>


  )
}

